/**
 * @generated SignedSource<<1b79f1b47f8b672c050e9b3320981d0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisconnectIntegrationInput = {
  clientMutationId?: string | null;
  id: string;
};
export type UserIntegrationsDisconnectIntegrationMutation$variables = {
  input: DisconnectIntegrationInput;
};
export type UserIntegrationsDisconnectIntegrationMutation$data = {
  readonly disconnectIntegration: {
    readonly deletedId: string | null;
    readonly error: string | null;
    readonly ok: boolean;
  } | null;
};
export type UserIntegrationsDisconnectIntegrationMutation = {
  response: UserIntegrationsDisconnectIntegrationMutation$data;
  variables: UserIntegrationsDisconnectIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DisconnectIntegrationPayload",
    "kind": "LinkedField",
    "name": "disconnectIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserIntegrationsDisconnectIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserIntegrationsDisconnectIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc3a3fb037ada7a80f76a8ffab19b02d",
    "id": null,
    "metadata": {},
    "name": "UserIntegrationsDisconnectIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation UserIntegrationsDisconnectIntegrationMutation(\n  $input: DisconnectIntegrationInput!\n) {\n  disconnectIntegration(input: $input) {\n    ok\n    error\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bc1900e95228b97ed4cc525cdec788b";

export default node;
